import { useEffect } from 'react';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA1ehvRfntuaFc0xRFORS-zx13NrsKNu14",
  authDomain: "acematch-424cd.firebaseapp.com",
  projectId: "acematch-424cd",
  storageBucket: "acematch-424cd.appspot.com",
  messagingSenderId: "747685802702",
  appId: "1:747685802702:web:e54fbb919e962d5d52569f",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const SaveToken = () => {
  useEffect(() => {
    const messaging = getMessaging(app);
    const auth = getAuth();

    auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const tokenDocRef = doc(db, "tokens", user.uid);
          const tokenDocSnap = await getDoc(tokenDocRef);

          if (tokenDocSnap.exists()) {
            const tokenData = tokenDocSnap.data();

            if (!('approve' in tokenData)) {
              // approveフィールドが存在しない場合、trueを追加
              await setDoc(tokenDocRef, { approve: true }, { merge: true });
            }

            if (tokenData.approve === false) {
              // approveがfalseならtokenをnullにする
              await setDoc(tokenDocRef, { token: null }, { merge: true });
            } else if (tokenData.approve === true) {
              // approveがtrueならtokenを取得して保存
              const currentToken = await getToken(messaging, { vapidKey: 'BOQlFlynawoiv-mauechKpC6F0LKgUudbuzcfO80eqJhlIdDUqPKR-VVnw-cJ6j2lG3_lRqtuWztwIK0SflphQo' });
              if (currentToken) {
                await setDoc(tokenDocRef, { token: currentToken }, { merge: true });
              }
            }
          } else {
            // ドキュメントが存在しない場合、新しく作成
            const currentToken = await getToken(messaging, { vapidKey: 'BOQlFlynawoiv-mauechKpC6F0LKgUudbuzcfO80eqJhlIdDUqPKR-VVnw-cJ6j2lG3_lRqtuWztwIK0SflphQo' });
            if (currentToken) {
              await setDoc(tokenDocRef, { uid: user.uid, approve: true, token: currentToken });
            }
          }
        } catch (error) {
          console.error('Error fetching or saving token:', error.message);
        }

        onMessage(messaging, (payload) => {
          // プッシュ通知の処理
        });
      }
    });
  }, []);

  return null;
};

export default SaveToken;
